import { useRef } from 'react';
import useIsomorphicEffect from '../../internal/useIsomorphicEffect';
/**
 *
 * @see https://sail.stripe.me/apis/react/useUpdateEffect
 */ export default function useUpdateEffect(/** The callback to execute when a change is detected. */ callback, /** The list of dependencies to monitor for changes. */ deps) {
    const init = useRef(false);
    useIsomorphicEffect(()=>{
        if (init.current) {
            callback();
        }
        init.current = true;
    }, deps);
}

//# sourceMappingURL=useUpdateEffect.js.map